import { render } from "./Slr.vue?vue&type=template&id=36a86974"
import script from "./Slr.vue?vue&type=script&lang=js"
export * from "./Slr.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__